// Product Gallery - Disable modal/lightbox only
document.addEventListener('DOMContentLoaded', function() {

  // Prevent modal from opening on image click
  document.querySelectorAll('.product__modal-opener').forEach(function(opener) {
    opener.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
    });
  });

});
